import _ from "lodash";
import * as DateUtils from "../../../../../../utils/date/date";
import { BrainTools } from "../../BrainTools/BrainTools";
import { CalcOperation } from "../../Operators/CalcOperations";
import { MathOperations } from "../../Operators/MathOperations";

/**
 * @class
 * Responsável pela processamento da criação de uma respota para Pessoal
 */
export class PersonnelMachine {
    constructor({ Serie } = {}) {
        this.Tools = new BrainTools();

        this.constants = {
            MES: true,
            QUANTIDADE: true
        };

        this.periods = {
            monthly: { count: 1 },
            quarterly: { count: 3, months: [3, 6, 9, 12] },
            semester: { count: 6, months: [6, 12] },
            yearly: { count: 12, months: [12] }
        };

        this.availableMonthsIndex = {
            monthly: [],
            quarterly: [
                [1, 2, 3],
                [4, 5, 6],
                [7, 8, 9],
                [10, 11, 12]
            ],
            semester: [
                [1, 2, 3, 4, 5, 6],
                [7, 8, 9, 10, 11, 12]
            ],
            yearly: [[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]]
        };

        this.Serie = Serie;
    }

    accumulator(
        serie,
        points,
        period,
        scenario,
        periodAccumulated,
        isAccumulated
    ) {
        if (period != "monthly" && !isAccumulated && !periodAccumulated) {
            const pointsWrapper = this._wrapperPoints(
                points.map((p) => p.t),
                points,
                period
            );

            const resPoints = [];

            pointsWrapper.forEach((pointWrapper) => {
                // let lastVal = 0;

                if (pointWrapper.pointsFrame.length) {
                    let curVal = pointWrapper.pointsFrame.reduce(
                        (sum, point, idx) => {
                            // if (idx === 0) sum = lastVal;
                            sum = sum + _.get(point, "m.f", 0);
                            return sum;
                        },
                        0
                    );

                    // lastVal = curVal;

                    resPoints.push({
                        t: DateUtils.getDate(
                            `${pointWrapper.year}/${
                                this.periods[period]["months"][pointWrapper.key]
                            }/1`
                        ),
                        s: serie._id,
                        c: serie.companyId,
                        sc: scenario,
                        u: DateUtils.getDate(new Date()),
                        m: { v: curVal },
                        period
                    });
                }
            });

            return resPoints;
        } else {
            return points.map((p) => {
                p.period = period;
                return p;
            });
        }
    }

    run(
        serie,
        points,
        scenario,
        period,
        timesAvailable,
        opts = {},
        _source,
        totalCompanies
    ) {
        const pointsSorted = _.sortBy(points, ["t"]);

        timesAvailable = !timesAvailable
            ? Object.keys(_.groupBy(pointsSorted, "t"))
            : timesAvailable;

        const pointsCalculated = [];

        const serieMinValue = _.get(serie, "metadata.minValue", null);

        if (!timesAvailable[0]) return [];

        if (period === "monthly") {
            for (let i in timesAvailable) {
                let time = DateUtils.getDate(timesAvailable[i]);

                let year = time.getFullYear();
                let exp = this.Tools.rulesRemove(serie.exp);
                const variables = this.Tools.expressionSplit(serie.exp);

                for (let j in variables) {
                    let variable = variables[j];
                    exp = this._processRule(
                        exp,
                        variable,
                        pointsSorted.filter((p) => p.period === "monthly"),
                        time,
                        year,
                        scenario,
                        serie,
                        opts,
                        totalCompanies
                    );
                }

                exp = exp.replace(/\[|\]/g, "");

                const expValue = MathOperations(exp);

                let expResult = 0;

                if (serieMinValue) {
                    expResult =
                        expValue > serieMinValue ? expValue : serieMinValue;
                } else if (isFinite(expValue)) {
                    expResult = expValue;
                }

                pointsCalculated.push({
                    t: time,
                    s: serie._id,
                    c: serie.companyId,
                    so: _source,
                    sc: scenario,
                    u: DateUtils.getDate(new Date()),
                    m: { v: expResult },
                    period: "monthly"
                });
            }
        } else {
            const compound = Object.keys(_.groupBy(pointsSorted, "s"));

            const pointsWrappedPerPeriod = this._wrapperPoints(
                timesAvailable,
                pointsSorted,
                period
            );

            const pointsPerPeriod = pointsWrappedPerPeriod.reduce(
                (acc, pWrapped) => {
                    if (pWrapped.pointsFrame.length) {
                        compound.forEach((serieId) => {
                            const currentPointsFrameSerie = pWrapped.pointsFrame.filter(
                                (p) => p.s === serieId
                            );

                            const serie = this.Serie.findOneCollection({
                                _id: serieId
                            });

                            const last = _.last(currentPointsFrameSerie);

                            let curVal = _.get(
                                last,
                                "m.v",
                                _.get(last, "m.f", 0)
                            );

                            if (
                                _.get(serie, "metadata.periodAccumulated", true)
                            ) {
                                curVal = currentPointsFrameSerie.reduce(
                                    (sum, point) => {
                                        sum =
                                            sum +
                                            _.get(
                                                point,
                                                "m.v",
                                                _.get(point, "m.f", 0)
                                            );
                                        return sum;
                                    },
                                    0
                                );
                            }

                            acc.push({
                                t: DateUtils.getDate(
                                    `${pWrapped.year}/${
                                        this.periods[period]["months"][
                                            pWrapped.key
                                        ]
                                    }/1`
                                ),
                                s: serieId,
                                so: _source,
                                c: serie.companyId,
                                sc: scenario,
                                u: DateUtils.getDate(new Date()),
                                m: { v: curVal },
                                period
                            });
                        });
                    }

                    return acc;
                },
                []
            );

            for (let timeAvailable of timesAvailable) {
                let time = DateUtils.getDate(timeAvailable);

                const availableMonth = parseInt(
                    DateUtils.dateToString(time, "M")
                );

                if (!this.periods[period].months.includes(availableMonth))
                    continue;

                let year = time.getFullYear();
                let exp = this.Tools.rulesRemove(serie.exp);
                const variables = this.Tools.expressionSplit(serie.exp);

                for (let j in variables) {
                    let variable = variables[j];
                    exp = this._processRulePerPeriod(
                        period,
                        exp,
                        variable,
                        pointsPerPeriod,
                        time,
                        year,
                        scenario,
                        serie,
                        opts,
                        totalCompanies
                    );
                }

                exp = exp.replace(/\[|\]/g, "");

                const expValue = MathOperations(exp);

                let expResult = 0;

                if (serieMinValue) {
                    expResult =
                        expValue > serieMinValue ? expValue : serieMinValue;
                } else if (isFinite(expValue)) {
                    expResult = expValue;
                }

                pointsCalculated.push({
                    t: time,
                    s: serie._id,
                    so: _source,
                    c: serie.companyId,
                    sc: scenario,
                    u: DateUtils.getDate(new Date()),
                    m: { v: expResult },
                    period
                });
            }
        }

        return pointsCalculated;
    }

    _wrapperPoints(availables, points, period) {
        const years = _.uniq(
            availables.map((t) => DateUtils.getDate(t).getFullYear())
        );

        const pointsWrapper = this.availableMonthsIndex[period].reduce(
            (acc, arrMonth, idx) => {
                years.forEach((year) => {
                    let pointsFrame = points.filter(
                        (p) =>
                            arrMonth.includes(
                                parseInt(DateUtils.dateToString(p.t, "M"))
                            ) && year === p.t.getFullYear()
                    );

                    acc.push({
                        key: idx,
                        year,
                        pointsFrame
                    });
                });

                return acc;
            },
            []
        );

        return pointsWrapper;
    }

    _processRule(
        exp,
        variable,
        pointsSorted,
        time,
        year,
        scenario,
        serie,
        opts = {},
        totalCompanies
    ) {
        let value = 0;
        let currentPoint = {};
        const rule = this.Tools.ruleExtract(variable);

        variable = this.Tools.serieIdExtract(variable);

        const regex = this.Tools.serieExchangeReference(variable);

        variable = this.Tools.specialCharacterRemove(variable);

        for (let i in pointsSorted) {
            let point = pointsSorted[i];
            if (
                (point.t.getTime() == time.getTime() && variable === point.s) ||
                point === 0
            ) {
                currentPoint = point;
                break;
            }
        }

        if (_.isEmpty(currentPoint)) {
            currentPoint = {
                t: time,
                m: { v: 0 },
                s: variable,
                so: "personnel",
                sc: scenario,
                _id: "GHOST" + new Date().getTime()
            };

            pointsSorted.push(currentPoint);

            pointsSorted = _.sortBy(pointsSorted, "t");
        }

        const pointsByYear = _.filter(
            pointsSorted,
            (p) =>
                p.s === currentPoint.s &&
                (p.t.getFullYear() === year ||
                    (p.t.getFullYear() === year - 1 &&
                        parseInt(DateUtils.dateToString(p.t, "M")) === 12))
        );

        if (!_.isEmpty(currentPoint)) {
            value = this._getValueByCondition({
                time,
                rule,
                variable,
                scenario,
                serie,
                currentSerieId: currentPoint.s,
                currentPoint: currentPoint.m,
                points: pointsByYear,
                opts,
                totalCompanies
            });
        }

        if (value) value = value.toFixed(2);
        if (isNaN(value)) value = 0;

        return exp.replace(regex, ` ${value} `);
    }

    _processRulePerPeriod(
        period,
        exp,
        variable,
        pointsSorted,
        time,
        year,
        scenario,
        serie,
        opts = {},
        totalCompanies
    ) {
        let value = 0;
        let currentPoint = {};
        const rule = this.Tools.ruleExtract(variable);

        variable = this.Tools.serieIdExtract(variable);

        const regex = this.Tools.serieExchangeReference(variable);

        variable = this.Tools.specialCharacterRemove(variable);

        for (let i in pointsSorted) {
            let point = pointsSorted[i];
            if (
                (point.t.getTime() == time.getTime() && variable === point.s) ||
                point === 0
            ) {
                currentPoint = point;
                break;
            }
        }

        if (_.isEmpty(currentPoint)) {
            currentPoint = {
                t: time,
                m: { v: 0 },
                s: variable,
                so: "personnel",
                sc: scenario,
                _id: "GHOST" + new Date().getTime()
            };

            pointsSorted.push(currentPoint);

            pointsSorted = _.sortBy(pointsSorted, "t");
        }

        const pointsByYear = _.filter(
            pointsSorted,
            (p) =>
                p.s === currentPoint.s &&
                (p.t.getFullYear() === year ||
                    (p.t.getFullYear() === year - 1 &&
                        parseInt(DateUtils.dateToString(p.t, "M")) === 12))
        );

        if (!_.isEmpty(currentPoint)) {
            value = this._getValueByConditionPerPeriod({
                period,
                time,
                rule,
                variable,
                scenario,
                serie,
                currentSerieId: currentPoint.s,
                currentPoint: currentPoint.m,
                points: pointsByYear,
                opts,
                totalCompanies
            });
        }

        if (value) value = value.toFixed(2);
        if (isNaN(value)) value = 0;

        return exp.replace(regex, ` ${value} `);
    }

    /**
     * @private
     * Realiza tratamento dos values de points de acordo com uma condição de calculo
     * @param {Object} point point que ira receber uma condição
     * @param {Array} points todos os points usados no kpi, para realizar tratamentos
     */
    _getValueByCondition({
        time,
        serie,
        currentPoint,
        currentSerieId,
        points,
        variable,
        rule,
        opts,
        totalCompanies
    } = {}) {
        const clonedPoints = _.cloneDeep(points);
        const isAccumulated = _.get(serie, "metadata.accumulated", false);
        const currentSerie =
            this.Serie.findOneCollection({
                _id: currentSerieId
            }) || {};

        const monthPeriod = 1;

        const ruleMap = {
            temporal: this._temporalRule,
            accumulated: this._accumulatedRule,
            default: this._defaultRule
        };

        if (this.constants[variable])
            return CalcOperation.isConstant(variable, time, points);

        if (!currentPoint) return 0;

        const ruleKey =
            _.get(rule, "i", false) && !isAccumulated
                ? "temporal"
                : isAccumulated
                ? "accumulated"
                : "default";

        let val = this._monthlyValueCalc({
            serie,
            currentSerie,
            time,
            monthPeriod,
            rule,
            ruleKey,
            ruleMap,
            clonedPoints,
            currentPoint
        });

        if (
            !currentSerie.groupId &&
            opts.avg &&
            serie.groupId &&
            !serie.metadata.kpi &&
            currentSerie.unit != "percentage"
        ) {
            val = +(val / totalCompanies).toFixed(2);
        }

        return val;
    }

    /**
     * @private
     * Realiza tratamento dos values de points de acordo com uma condição de calculo
     * @param {Object} point point que ira receber uma condição
     * @param {Array} points todos os points usados no kpi, para realizar tratamentos
     */
    _getValueByConditionPerPeriod({
        period,
        time,
        serie,
        currentPoint,
        currentSerieId,
        points,
        variable,
        rule,
        opts,
        totalCompanies
    } = {}) {
        const clonedPoints = _.cloneDeep(points);
        const isAccumulated = _.get(serie, "metadata.accumulated", false);
        const currentSerie = this.Serie.findOneCollection({
            _id: currentSerieId
        });

        const monthPeriod = this.periods[period].count;

        const ruleMap = {
            temporal: this._temporalRule,
            accumulated: this._accumulatedRule,
            default: this._defaultRule
        };

        if (this.constants[variable])
            return CalcOperation.isConstant(variable, time, points);

        if (!currentPoint) return 0;

        const ruleKey =
            _.get(rule, "i", false) && !isAccumulated
                ? "temporal"
                : isAccumulated
                ? "accumulated"
                : "default";

        this.availableMonthsIndex[period].reduce((acc, monthsArr) => {});

        let val = this._monthlyValueCalc({
            serie,
            currentSerie,
            time,
            monthPeriod,
            rule,
            ruleKey,
            ruleMap,
            clonedPoints,
            currentPoint
        });

        if (
            !currentSerie.groupId &&
            opts.avg &&
            serie.groupId &&
            !serie.metadata.kpi &&
            currentSerie.unit != "percentage"
        ) {
            val = +(val / totalCompanies).toFixed(2);
        }

        return val;
    }

    _monthlyValueCalc({
        serie,
        currentSerie,
        time,
        monthPeriod,
        rule,
        ruleKey,
        ruleMap,
        clonedPoints,
        currentPoint
    }) {
        const isDisabled = _.get(serie, "metadata.disabled");

        let response = 0;

        if (isDisabled && !this.showDisabled) return 0;

        const paramsMap = {
            temporal: {
                time,
                rule,
                points: clonedPoints,
                monthPeriod
            },
            accumulated: {
                time,
                points: clonedPoints,
                currentPoint,
                currentSerie
            },
            default: { currentPoint }
        };

        response = ruleMap[ruleKey](paramsMap[ruleKey]);

        return response;
    }

    _temporalRule({ time, rule, points, monthPeriod }) {
        let total = 0;
        let constant = rule.i * monthPeriod;
        const prevP = _.find(points, {
            t: new Date(CalcOperation.helperMonths(time, constant))
        });

        if (_.get(prevP, "m", false))
            total =
                _.get(prevP, "m.f", undefined) ||
                _.get(prevP, "m.v", undefined) ||
                0;

        return total;
    }

    _accumulatedRule({ time, points, currentPoint, currentSerie }) {
        if (parseInt(DateUtils.dateToString(time, "M")) === 1)
            return (
                _.get(currentPoint, "f", undefined) ||
                _.get(currentPoint, "v", undefined) ||
                0
            );

        const currentPointIndex = points.findIndex(
            (p) => p.t.getTime() === time.getTime()
        );

        const pointsTimeFrame = points.slice(0, currentPointIndex + 1);

        if (!_.get(currentSerie, "metadata.accumulated")) {
            let pointSum = pointsTimeFrame.reduce((sum, point) => {
                if (time.getFullYear() === point.t.getFullYear()) {
                    sum +=
                        _.get(point, "m.f", undefined) ||
                        _.get(point, "m.v", undefined) ||
                        0;
                }

                return sum;
            }, 0);

            return pointSum;
        } else {
            return _.get(currentPoint, "v", undefined) || 0;
        }
    }

    _periodNotAccumulated({ points, monthIdx, year }) {
        let point = points.find(
            (p) =>
                p.t.getFullYear() === year &&
                parseInt(DateUtils.dateToString(p.t, "M")) === monthIdx + 1
        );

        return (
            _.get(point, "m.f", undefined) ||
            _.get(point, "m.v", undefined) ||
            0
        );
    }

    _defaultRule({ currentPoint }) {
        return (
            _.get(currentPoint, "f", undefined) ||
            _.get(currentPoint, "v", undefined) ||
            0
        );
    }
}
